import styled from "styled-components";

export const Container = styled.div`
    > p {
        font-size: 1rem;
        margin-top: 0.25rem;
    }
`